import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VisibilityOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"visibility_off"}/>
}
